<template>
    <b-form-group :label="label"
                  :invalid-feedback="errorTxt"
                  :state="state">
        <b-input-group :prepend="$t('group')">
            <b-form-select
                    v-model="inputVal"
                    :options="options"
                    :state="state"
                    :disabled="disabled || !client">
            </b-form-select>
            <b-input-group-append>
                <client-user-group :clientId="this.model.client"></client-user-group>
            </b-input-group-append>
        </b-input-group>
    </b-form-group>
</template>

<script>
    import ClientUserGroup from "../views/client/ClientUserGroup";

    export default {
        components: {ClientUserGroup},
        props: ['model', 'label', 'errors', 'disabled'],
        data() {
            return {
                inputVal: this.model['group'] ? this.model['group'] : null,
                state: null,
                errorTxt: '',
                options: [],
                client: this.model['client'] ? this.model['client'] : null
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val['group'];
                    if (val['client'] !== this.client) {
                        this.client = this.model['client'] ? this.model['client'] : null;
                        if (this.client != null) {
                            this.load()
                        } else {
                            this.options = [
                                {value: null, text: this.$t('default')}
                            ];
                            this.inputVal = null;
                        }
                    }
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model['group'] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                            return;
                        }
                    });
                }
                this.state = !hasErr;
            }
        },
        methods: {
            load() {
                this.options = [
                    {value: null, text: this.$t('default')}
                ];
                this.$bgService.get('/client-user-group', {
                    params: {
                        page: 1,
                        pageSize: 1000,
                        status: 0,
                        client: this.client
                    }
                }).then(response => {
                    let found = false;
                    response.data.docs.forEach(item => {
                        this.options.push({value: item._id, text: item.name});
                        if (item._id === this.model['group']) {
                            found = true;
                        }
                    });
                    if (found) {
                        this.inputVal = this.model['group'] ? this.model['group'] : null;
                    } else {
                        this.inputVal = null;
                    }
                });
            }
        },
        mounted() {
            this.$bus.$on('reloadGroupSelect', this.load);
            this.load();
        },
        beforeDestroy(){
            this.$bus.$off('reloadGroupSelect');
        },
        i18n: {
            messages: {
                en: {
                    group: 'Group',
                    default: 'Default'
                },
                vi: {
                    group: 'Nhóm',
                    default: 'Mặc định'
                }
            }
        }
    }
</script>